import axios from 'axios';
import qs from 'qs';

axios.defaults.headers.common.Authorization = localStorage.getItem('token');

export function setToken(token) {
    if (token) {
        localStorage.setItem('token', `Bearer ${token}`);
        axios.defaults.headers.common.Authorization = localStorage.getItem('token');
    } else {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common.Authorization;
    }
}

export function removeToken() {
    setToken(null);
}

function renderUrlTemplate(url: string, params: any) {
  // 需求：'building/{buildingId}' -> 'building/123'
  // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  return url.replace(/\{([^}]+)\}/g, (m, p) => {
    const ret = params[p];
    delete params[p];
    return ret;
  });
}

export function http_get<Opt, Res>(url: string) {
  return async (opt: Opt) => {
    const newUrl = renderUrlTemplate(url, opt);
    const res: unknown = await axios.get(newUrl, { params: opt, paramsSerializer: (p) => qs.stringify(p) });
    return res as { data: Res } | RespError;
  };
}

export function http_post<Opt, Res>(url: string) {
  return async (opt: Opt) => {
    const newUrl = renderUrlTemplate(url, opt);

    const res: unknown = await axios.post(newUrl, opt);
    return res as { data: Res } | RespError;
  };
}

export function http_put<Opt, Res>(url: string) {
  return async (opt: Opt) => {
    const newUrl = renderUrlTemplate(url, opt);
    const res: unknown = await axios.put(newUrl, opt);
    return res as { data: Res } | RespError;
  };
}

export function http_delete<Opt, Res>(url: string) {
  return async (opt: Opt) => {
    const newUrl = renderUrlTemplate(url, opt);
    const res: unknown = await axios.delete(newUrl, { data: opt });
    return res as { data: Res } | RespError;
  };
}

export interface RespError {
  status?: number;
  error: {
    message: string;
    code: number;
    details: string;
    validationErrors: null;
  };
}

export function error(resp): resp is RespError {
  if ('error' in resp) {
    return true;
  }
  return false;
}
